import React from 'react';
import { useNavigate } from 'react-router-dom';

const BackIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
    <polyline points="15 18 9 12 15 6"/>
  </svg>
);

const TopBar = ({ title, subtitle, showBack, backTo, rightAction, children }) => {
  const navigate = useNavigate();
  const handleBack = () => backTo ? navigate(backTo) : navigate(-1);

  return (
    <div className="top-bar">
      <div className="top-bar-row">
        {showBack && (
          <button onClick={handleBack} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'white', display: 'flex', alignItems: 'center', padding: '4px', marginLeft: '-4px', borderRadius: '6px' }} aria-label="Go back">
            <BackIcon />
          </button>
        )}
        <div style={{ flex: 1 }}>
          <h1 style={{ fontSize: '17px' }}>{title}</h1>
          {subtitle && <p style={{ fontSize: '11px', opacity: 0.85, marginTop: '1px' }}>{subtitle}</p>}
        </div>
        {rightAction && (
          <div>{rightAction}</div>
        )}
      </div>
      {children && <div style={{ marginTop: '8px' }}>{children}</div>}
    </div>
  );
};

export default TopBar;
